import { render, staticRenderFns } from "./CompanyEditModuleMetaDataExtraDossiers.vue?vue&type=template&id=1d62e078&"
import script from "./CompanyEditModuleMetaDataExtraDossiers.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditModuleMetaDataExtraDossiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d62e078')) {
      api.createRecord('1d62e078', component.options)
    } else {
      api.reload('1d62e078', component.options)
    }
    module.hot.accept("./CompanyEditModuleMetaDataExtraDossiers.vue?vue&type=template&id=1d62e078&", function () {
      api.rerender('1d62e078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditModuleMetaDataExtraDossiers.vue"
export default component.exports